import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type { PortfolioConfigurationModel } from 'src/tpbp-json-api-handler/models/models'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const portfolioConfigurationFields: FieldInterface[] = [
  {
    key: 'hasSingleOwner',
    originKey: 'has_single_owner',
    type: FIELD_TYPES.boolean,
  },
  {
    key: 'productCategory',
    originKey: 'product_category',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'productCategoryLabel',
    originKey: 'product_category_label',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'productKind',
    originKey: 'product_kind',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'productKindLabel',
    originKey: 'product_kind_label',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'productKindOrder',
    originKey: 'product_kind_order',
    type: FIELD_TYPES.number,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'productType',
    originKey: 'product_type',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'schema',
    originKey: 'schema',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isReadOnly,
    objectType: 'ConfigurationSchema',
    objectTypePath: 'src/configuration.types',
  },
  {
    key: 'dependentObjects',
    originKey: 'dependent_objects',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isReadOnly,
    objectType: 'PortfolioConfigurationDependantObjects',
    objectTypePath: 'src/global-types',
  },
  {
    key: 'productGroup',
    originKey: 'product_group',
    type: FIELD_TYPES.string,
  },
  {
    key: 'productGroupLabel',
    originKey: 'product_group_label',
    type: FIELD_TYPES.string,
  },
  {
    key: 'productGroupMacro',
    originKey: 'product_group_macro',
    type: FIELD_TYPES.string,
    enumType: 'PortfolioConfigurationGroupMacro',
    enumTypePath: 'src/services/mappings/portfolio/portfolio.types',
  },
  {
    key: 'productGroupMacroLabel',
    originKey: 'product_group_macro_label',
    type: FIELD_TYPES.string,
  },
  {
    key: 'additionalRules',
    originKey: 'additional_rules',
    type: FIELD_TYPES.object,
  },
  {
    key: 'productGroupOrder',
    originKey: 'product_group_order',
    type: FIELD_TYPES.number,
    isPseudoAttribute: true,
    expression: (record: PortfolioConfigurationModel) =>
      record._productGroupConfiguration?.productGroupOrder,
  },
  {
    key: 'hidden',
    originKey: 'hidden',
    type: FIELD_TYPES.boolean,
    rule: FIELD_RULES.isReadOnly,
  },
]

const portfolioConfigurationRelations: RelationInterface[] = [
  {
    key: '_productGroupConfiguration',
    originKey: 'product_group_configuration',
    objectType: OBJECT_TYPES.productGroupConfiguration,
    isMultiple: false,
  },
]

export { portfolioConfigurationFields, portfolioConfigurationRelations }
